function showHidePasswordEntry() {
    const show = jQuery('[name="CheckoutAsGuest"]:checked').val();
    if (show === 'false')
        jQuery('[data-contact-information] [data-password-entry]').show()
    else
        jQuery('[data-contact-information] [data-password-entry]').hide()
}

export function initEnterEmail() {
    jQuery(document).on('change', '[data-contact-information] [name="CheckoutAsGuest"]', (event) => {
        showHidePasswordEntry()
    })
    showHidePasswordEntry();
}
